module.exports = __webpack_public_path__ + "img/Girl_020021.6742897c.png";